import { render, staticRenderFns } from "./ServiceTicketWidget.vue?vue&type=template&id=44886a1b&scoped=true&"
import script from "./ServiceTicketWidget.vue?vue&type=script&lang=js&"
export * from "./ServiceTicketWidget.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTicketWidget.vue?vue&type=style&index=0&id=44886a1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44886a1b",
  null
  
)

export default component.exports